import { CommonModule } from '@angular/common';
import { Component, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';

import { Subscription } from 'rxjs';

import { HttpStatusCodes } from '@constant/http-status-code-constant';
import { ApiResponse } from '@models/class/api-response';
import { AuthService } from '@services/auth.service';
import { NavigationService } from '@services/navigation.service';

@Component({
  selector: 'app-under-maintenance',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './under-maintenance.component.html',
  styleUrl: './under-maintenance.component.scss',
})
export class UnderMaintenanceComponent implements OnDestroy {
  /**
   * Initialization
   */
  loading = false; // spinner for Try Again
  private readonly subscription: Subscription = new Subscription();

  constructor(
    private readonly navigationService: NavigationService,
    private readonly router: Router,
    private readonly authService: AuthService,
  ) {
    this.onTryAgain();
  }

  /**
   * Handles the "Try Again" action
   * @returns
   */
  onTryAgain() {
    this.loading = true;
    const checkUnderMaintenanceStatusSubscription = this.navigationService.checkUnderMaintenanceStatus().subscribe({
      next: (response: ApiResponse<unknown>) => {
        this.loading = false;
        // If service returns success, navigate to home
        if (response?.isSuccess && response?.statusCode === HttpStatusCodes.SUCCESS_CODE) {
          this.authService.triggerRefresh();
          this.router.navigate(['/'], { queryParams: { refresh: new Date().getTime() } });
        }
      },
      error: () => {
        this.loading = false; // stay on page
      },
    });
    this.subscription.add(checkUnderMaintenanceStatusSubscription);
  }

  /*
   * Lifecycle hook — unsubscribes from all active observables and removes the popstate
   * handler to prevent memory leaks when the component is destroyed.
   */
  ngOnDestroy() {
    // Unsubscribe from all subscriptions
    this.subscription.unsubscribe();
    window.onpopstate = null; // clean up
  }
}
